/* ============================================================================
   scroll-fade.js — horizontal wischbare Leiste mit ausblendendem rechten Rand
   (<nko-scroll-fade>)
   ----------------------------------------------------------------------------
   Geladen von snippets/nko-collection-header.liquid (Filter-Leisten der
   Kollektionsseite). Das Element setzt `data-scrollable`, solange rechts noch
   Inhalt folgt; den Verlauf selbst macht das CSS
   (assets/section-main-collection.css, `.subcollection--row[data-scrollable]`).
   Am Ende der Leiste faellt das Attribut weg, die letzte Kachel ist dann voll
   sichtbar. Ohne dieses Skript bleibt die Leiste wischbar, nur ohne Verlauf.

   WARUM EIN CUSTOM ELEMENT: Der Kopfbereich der Kollektion wird von
   collection.js neu gerendert, Inline-Skripte im eingesetzten HTML laufen
   dabei nicht (docs/css-architektur.md §2.5). connectedCallback deckt das
   Neurendern ab.

   AUF- UND ABBAU: Scroll-Hoerer am AbortController, Groessenwechsel ueber
   einen ResizeObserver; disconnectedCallback raeumt beides ab.
   ============================================================================ */

class ScrollFade extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const aktualisieren = () => {
      const rest = this.scrollWidth - this.clientWidth - this.scrollLeft;
      this.toggleAttribute('data-scrollable', rest > 4);
    };
    this.addEventListener('scroll', aktualisieren, { passive: true, signal: this.abort.signal });
    this.beobachter = new ResizeObserver(aktualisieren);
    this.beobachter.observe(this);
    aktualisieren();
  }

  disconnectedCallback() {
    this.abort?.abort();
    this.beobachter?.disconnect();
  }
}

if (!customElements.get('nko-scroll-fade')) customElements.define('nko-scroll-fade', ScrollFade);
